import { DetectorConfig, Id } from 'NSwag/ServerClient/Client.nswag';
import { Action } from 'redux';

export enum DetectorActionTypes {
    AddDetectors = "ADD_DETECTORS",
    ModifyDetectors = "MODIFY_DETECTORS",
    DeleteDetectors = "DELETE_DETECTORS"
}

export interface AddDetectors extends Action{
    type: DetectorActionTypes.AddDetectors;
    detectors: DetectorConfig[];
}

export interface ModifyDetectors extends Action {
    type: DetectorActionTypes.ModifyDetectors;
    detectors: DetectorConfig[];
}

export interface DeleteDetectors extends Action {
    type: DetectorActionTypes.DeleteDetectors;
    ids: Id[];
}